import styled, { css } from 'styled-components';

import CloseButton from '../../buttons/_CloseButton';
import media from '../../../utils/styling/media';

export const StyledSnackbarWrapper = styled.div`
  position: fixed;
  left: 0;
  width: 100%;
  height: 0;
  display: flex;
  z-index: 100000;
  justify-content: center;

  ${media.xs`
    bottom: 0;  
    `}
  
  ${media.md`
    bottom: auto;  
    top: 0;  
  `}
`;

type StyledNotificationProps = {
  opened?: boolean;
  closing?: boolean;
  topMargin?: number;
  bottomMargin?: number;
};

export const StyledNotification = styled.div<StyledNotificationProps>`
  position: relative;
  background: ${({ theme }) => theme.colors.black80};
  color: ${({ theme }) => theme.colors.white};
  border-radius: 4px;
  padding: 16px 36px 16px 16px;
  transition: transform ease-out 0.3s;
  width: 560px;
  max-width: calc(100% - 32px);
  height: 50px;
  box-sizing: border-box;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  ${({ closing }) => closing && css`
    transition: transform ease-out 0.15s;
  `}

  ${media.xs<StyledNotificationProps>`
    margin-bottom: ${({ bottomMargin }) => bottomMargin}px;
    transform: translate3d(0, 0, 0);
    

    ${({ opened }) => opened && css<StyledNotificationProps>`
    transform: translate3d(0, -${({ bottomMargin }) => bottomMargin + 50}px, 0);
    `}
  `}
  
  ${media.md<StyledNotificationProps>`
    margin-top: ${({ topMargin }) => topMargin}px;
    margin-bottom: 0;
    transform: translate3d(0, -${({ topMargin }) => topMargin + 50}px, 0);

    ${({ opened }) => opened && css`
      transform: translate3d(0, 0, 0);
    `}
  `}
`;

export const StyledCloseButton = styled(CloseButton)`
  position: absolute;
  top: 2px;
  right: 4px;
`;
